import axios from 'axios';
import { useMemo, useCallback } from 'react';
import { BrandName } from '@packlink/brands';
import { useTenantConfig } from '@packlink/tenant-config-provider';

function useTenantIconResolver(cdnUrl, iconIndex) {
  const urlDefaultIcon = useMemo(() => `${cdnUrl}/brand/${BrandName.FALLBACK}/icons/file.svg`, [cdnUrl]);
  const {
    brand
  } = useTenantConfig() || {
    brand: BrandName.FALLBACK
  };
  const brandName = brand === null || brand === void 0 ? void 0 : brand.toLowerCase();

  // Function get icon from cdn depending on the brand
  const resolveIcon = useCallback(iconName => {
    const getIcon = url => axios.get(url).then(res => res.data).catch(() => axios.get(urlDefaultIcon).then(res => res.data));
    if (iconIndex) {
      try {
        const brandHasIcon = (iconIndex[(iconName !== null && iconName !== void 0 ? iconName : '').toLowerCase()] || []).includes(brandName);
        const iconBrand = brandHasIcon ? brandName : BrandName.FALLBACK;
        const url = `${cdnUrl}/brand/${iconBrand}/icons/${iconName.toLowerCase()}.svg`;
        return getIcon(url);
      } catch {
        return getIcon(urlDefaultIcon).catch(() => '');
      }
    }
    return Promise.resolve('');
  }, [brandName, cdnUrl, iconIndex, urlDefaultIcon]);
  return resolveIcon;
}

export { useTenantIconResolver };
//# sourceMappingURL=useIconLoader.js.map
